import { formatPhone } from '../../../../../../../../../../../../common/functions/formatPhone';
import { BrokerAgreementSummary } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement broker's email and phone. */
export const BrokerContact = ({ broker }: { broker: NonNullable<BrokerAgreementSummary['broker']> }) => {
    return (
        <>
            {broker.email && <div>{broker.email}</div>}
            {broker.phone && <div>{formatPhone(broker.phone)}</div>}
        </>
    );
};
